/**
 * 如实告知“内容会交给外部服务处理”（DATA-USE-COPY-01；c84a REPLY-I-20261009-31 第 29 项、-32 05:46Z 补充裁定；I 10-09 派、6c2b 10-09 定第二版）。
 * - 用户 09-29 去掉的是配图上的 AI 角标和“不是真实照片”这类标注，这条照旧：玩家界面不写 AI 字样。
 *   但内容会交给外部服务处理要照实说，不能因为不写 AI 就说成只在本机。
 * - 私聊里第一次出现的提示、设置页“隐私说明”第一句：c84a 原句＋“查看内容使用说明”链接（DataUseLink），去 /settings/data-use。
 * - 上传照片的地方（建宠首只、再添一只、形象页补照片、换照片）：一句照片交给外部图像服务＋“查看内容使用说明”，
 *   普通点按**原地打开**共享底部面板（shared/ui 的 Sheet）——不离开当前页，已选的照片、填好的名字都还在。
 *   面板按场合只放「照片」一节（DATA-USE-COPY-01-R1，I 10-09 收包意见）：PhotoDataUseContent，和详情页同一份「照片」一节、只取图像两种用途的
 *   「目前在用」，最后一行用文字指路「完整的内容使用说明在 设置 › 内容使用说明」，面板里没有任何跳转链接（点了会离开、表单会丢）。
 *   它仍是一个去 /settings/data-use 的链接（带修饰键、中键点交给浏览器，新标签里看整页）；不做成按钮：形象页“没选图时卡里没有任何按钮”
 *   那几条旧保护（look-photo、look 用例）照旧成立。读屏读作链接，带 aria-haspopup=dialog 和 aria-expanded。
 * - 品牌不进这几句、不进按钮和标题；服务名只在说明里“目前在用”那一行出现。
 * - 链接、按钮点按区 44px（dataUse.css）；颜色沿用通讯器那句说明里链接的写法（communicator.css 的 .ps-comm-model-note__actions a），不另起色值。
 */
import { useState, type MouseEventHandler } from "react";
import { Link } from "react-router";
import { Sheet } from "@/shared/ui";
import { DATA_USE_TITLE, PHOTO_DATA_USE, PhotoDataUseContent } from "./DataUseContent";
import "./dataUse.css";

export { CHAT_DATA_USE, PHOTO_DATA_USE } from "./DataUseContent";

/** 说明页的路径：不套主布局（不被入住守卫带走） */
export const DATA_USE_PATH = "/settings/data-use";
export const DATA_USE_LINK_TEXT = "查看内容使用说明";

/** 私聊提示、设置页隐私卡：去说明页 */
export function DataUseLink({ onClick, className }: { onClick?: MouseEventHandler<HTMLAnchorElement>; className?: string }) {
  return (
    <Link to={DATA_USE_PATH} className={["ps-data-use-link", className ?? ""].join(" ").trim()} onClick={onClick}>
      {DATA_USE_LINK_TEXT}
    </Link>
  );
}

/** 上传照片处的一句告知：次要文字，不抢主操作；“查看内容使用说明”原地打开底部面板。建宠页照片说明居中，跟着居中 */
export function PhotoDataUseNote({ align = "start" }: { align?: "start" | "center" }) {
  const [open, setOpen] = useState(false);
  // 普通左键：不跳页，原地打开；修饰键、中键交给浏览器（新标签页打开整页说明）
  const openHere: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    setOpen(true);
  };
  return (
    <div className={`ps-data-use-note${align === "center" ? " ps-data-use-note--center" : ""}`} data-testid="photo-data-use">
      <p>{PHOTO_DATA_USE}</p>
      <Link to={DATA_USE_PATH} className="ps-data-use-link" aria-haspopup="dialog" aria-expanded={open} onClick={openHere}>
        {DATA_USE_LINK_TEXT}
      </Link>
      {open ? (
        <Sheet title={DATA_USE_TITLE} onClose={() => setOpen(false)} className="ps-data-use-sheet">
          <PhotoDataUseContent />
        </Sheet>
      ) : null}
    </div>
  );
}
